import { Toolbar, AppBar, Box, Typography, Tooltip, Button } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { ReactComponent as Logo } from "./../../../logo.svg";
import { useDispatch, useSelector } from "react-redux";
import authService from "../../../services/authService";
import { useEffect, useState } from "react";
import { refereeSelector,daysLeftSelector } from "../../../store/refereeSlice";
import { useHistory } from "react-router";
import { MAIN_PAGE_URL } from "../Constants";
import { contactSelector } from "../../../store/userSlice";
import TimerIcon from "@mui/icons-material/Timer";

export const toolbarHeight = 80;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "flex-end",
    "& > *": {
      marginLeft: theme.spacing(6),
    },
    marginRight: theme.spacing(2),
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  toolbar: {
    paddingRight: theme.spacing(1),
    minHeight: toolbarHeight,
    backgroundColor: process.env.REACT_APP_TOOLBAR_COLOR || "#FFF",
    color: "black",
  },
  pairsValue: {
    fontWeight: 600,
    marginLeft: 7,
  },
  buttonsWrapper: {
    "& > *": {
      marginLeft: theme.spacing(1),
    },
  },
  logoutButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.red.hover,
    },
    color: theme.palette.gif.red.color,
    backgroundColor: theme.palette.gif.red.background,
  },
  logo: {
    position: "absolute",
    left: 85,
  },
  dashboardButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: "#FFFFFF",
    backgroundColor: theme.palette.gif.blue.color,
  },
}));

export default function ApplicationBar(props) {
  const classes = useStyles();
  const { showProposalInfo, showDashboardButton } = props;
  const dispatch = useDispatch();

  const history = useHistory();
  const referee = useSelector(refereeSelector);
  const contact = useSelector(contactSelector);
  const daysLeft = useSelector(daysLeftSelector);
  
  const [infos, setInfos] = useState([]);

  useEffect(() => {
    const infos = [
      { key: "Referee", value: contact?.displayname || "" },
      { key: "ID", value: referee?.idName || "" },
      { key: "Proposal", value: referee?.title || "" },
      { key: "Program", value: referee?.program || "" },
      {
        key: "Deadline",
        value: daysLeft?.totalDaysLeft || 0,
        icon: TimerIcon,
        tooltip: `Due date: ${daysLeft?.endFormatted}`,
      },
      
    ];
    setInfos(infos);
  }, [referee, contact,daysLeft]);

  const logout = () => {
    authService.logout();
    dispatch({ type: "USER_LOGGED_OUT" });
  };

  return (
    <AppBar position="absolute" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <Logo className={classes.logo} onClick={() => history.push("/")} />
        <Box className={classes.root}>
          {showProposalInfo &&
            infos.map(
              (info) =>
                info.value !== "" && (
                  <Tooltip
                    title={info.tooltip || ""}
                    placement="bottom"
                    key={info.key}
                  >
                    <Box key={info.key}>
                      <Typography
                        className={classes.pairsKey}
                        component="span"
                        variant="subtitle2"
                        color="inherit"
                        noWrap
                      >
                        {info.key}
                      </Typography>
                      <Typography
                        className={classes.pairsValue}
                        component="span"
                        color="inherit"
                        noWrap
                      >
                        {info.value}
                      </Typography>
                    </Box>
                  </Tooltip>
                )
            )}
          <Box className={classes.buttonsWrapper}>
            {showDashboardButton && (
              <Button
                variant="contained"
                color="secondary"
                className={classes.dashboardButton}
                disableElevation
                onClick={() => history.push(MAIN_PAGE_URL)}
              >
                Dashboard
              </Button>
            )}
            <Button
              variant="contained"
              color="secondary"
              className={classes.logoutButton}
              disableElevation
              onClick={logout}
            >
              Logout
            </Button>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
